<template>
  <NuxtLoadingIndicator color="#6767E4" />
  <NuxtLayout>
    <NuxtPage />
    <client-only>
      <iframe
        src="https://7bitcasino.com/service-src/gtm-rm"
        sandbox="allow-scripts"
        width="0"
        height="0"
        style="display: none; visibility: hidden"
      />
    </client-only>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { useStoreSsPaymentMethods } from '~/stores/softswiss/paymentMethods';
import { useBlockedLocalStoreRemove } from '~/utils/blockedLocalStoreRemove';
import { useDeferredPrompt } from './composables/useDeferredPrompt';
import { useStoreRoot } from './stores/abstract/root';
import { useStoreQuery } from './stores/client/query';
import { useStoreMatch2One } from './stores/services/match2one';
import { useStoreSystemHosts } from './stores/strapi/systemHosts';
import '@bit/ui-kit/styles';
import '@/assets/styles/loader.css';
import '@/assets/styles/default.css';
import '@/assets/styles/main.scss';
import '@/assets/ui-kit/reset.scss';
import '@/assets/ui-kit/modals.scss';
import '@/assets/ui-kit/typography.scss';

const platform = usePlatform();
const route = useRoute();
const router = useRouter();
const storeRoot = useStoreRoot();
const deferredPrompt = useDeferredPrompt();

function handleDisplayModeChange() {
  storeRoot.checkIsPwaInstalled();
}

if (import.meta.browser) {
  watch(
    () => import.meta.browser && route.fullPath,
    () => {
      useStoreQuery().updateRoute(route);
    },
    { immediate: true }
  );

  useBlockedLocalStoreRemove();
}

watch(
  () => deferredPrompt.value,
  () => {
    storeRoot.checkIsPwaInstalled();
  },
  { immediate: true }
);

// Setup event listeners for resizing
onMounted(() => {
  useStoreSsPaymentMethods().loadPaymentLib();
  useStoreSystemHosts().loadSystemHost();
  useStoreMatch2One().loadUniversalScript();
  platform.updateScreenSize();
  window.addEventListener('resize', platform.updateScreenSize);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', platform.updateScreenSize);
  }

  const mediaQuery = window.matchMedia('(display-mode: standalone)');

  mediaQuery.addEventListener('change', handleDisplayModeChange);

  window.addEventListener('appinstalled', () => {
    window.OneSignalDeferred?.push(async function (OneSignal) {
      const userId = window.OneSignal.User.externalId;
      if (userId) {
        await OneSignal.User.addTag('install', 'true');
      }
    });
    router.push(storeRoot.localePath('/'));
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', platform.updateScreenSize);
  if (window.visualViewport) {
    window.visualViewport.removeEventListener('resize', platform.updateScreenSize);
  }
});
</script>
